import { settingsAxiosInstance } from "./axiosInstances";
import { mapAllowedValues, mapKcVersionsAllowedValues } from "utils/Utils";

const SettingsService = {
    async getDedicatedClusterRegionOptions() {
        try {
            const resp = await settingsAxiosInstance.get("/", {
                params: {
                    filter: { key: "DEDICATED_DEPLOYMENTS_REGIONS" }
                }
            });

            const attributes = resp.data?.data?.[0]?.attributes ?? {};
            const regions = mapAllowedValues(attributes.allowed_values);

            return {
                default: JSON.parse(attributes.default_value || "{}"),
                regions
            };
        } catch (err) {
            console.warn("Failed to fetch dedicated region options", err);
            return { default: {}, regions: [] };
        }
    },

    async getSharedClusterRegionOptions() {
        try {
            const resp = await settingsAxiosInstance.get("/", {
                params: {
                    filter: { key: "SHARED_DEPLOYMENTS_REGIONS" }
                }
            });

            const attributes = resp.data?.data?.[0]?.attributes ?? {};
            const regions = mapAllowedValues(attributes.allowed_values);

            return {
                default: JSON.parse(attributes.default_value || "{}"),
                regions
            };
        } catch (err) {
            console.warn("Failed to fetch shared region options", err);
            return { default: {}, regions: [] };
        }
    },
    
    async getKeycloakVersions() {
        try {
            const resp = await settingsAxiosInstance.get("/", {
                params: {
                    filter: { key: "KEYCLOAK_VERSIONS" }
                }
            });

            const attributes = resp.data?.data?.[0]?.attributes ?? {};
            const kcVersions = mapKcVersionsAllowedValues(attributes.allowed_values);

            return {
                default: JSON.parse(attributes.default_value || "{}"),
                kcVersions
            };
        } catch (err) {
            console.warn("Failed to fetch keycloak versions options", err);
            return { default: {}, kcVersions: [] };
        }
    }
};

export default SettingsService;